import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { clmApiClient } from '../clients';
import type { Department } from '../types';

/**
 * Fetch all departments (id + name only, no pagination)
 */
const fetchAllDepartments = async (): Promise<
  Pick<Department, 'departmentId' | 'department'>[]
> => {
  const response = await clmApiClient.get('department/all');

  if (!response.ok) {
    throw new Error(`Error fetching all departments: ${response.problem}`);
  }

  return response.data as Pick<Department, 'departmentId' | 'department'>[];
};

export const useAllDepartments = (
  config?: Omit<
    UseQueryOptions<Pick<Department, 'departmentId' | 'department'>[]>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: ['departments', 'all'],
    queryFn: fetchAllDepartments,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...config,
  });
